import type { OpportunityOnboarding } from '@axiom/validation';

export type OnboardingPosition = NonNullable<
  OpportunityOnboarding['positions']
>[number];

export type OnboardingCandidateOpportunity = NonNullable<
  OnboardingPosition['candidateOpportunities']
>[number];

export type OnboardingDetails = NonNullable<
  OnboardingCandidateOpportunity['onboardingDetails']
>;

export const OnboardingUtil = {
  generateAddressDisplayName: (talent: {
    addressCity?: string | null;
    addressState?: string | null;
    addressCountry?: string | null;
  }): string => {
    return [talent.addressCity, talent.addressState, talent.addressCountry]
      .filter(Boolean)
      .slice(0, 2)
      .join(', ');
  },
  getEmailSentDate: (
    pos: OnboardingPosition
  ): NonNullable<
    OnboardingCandidateOpportunity['onboardingEmailSentAt']
  > | null => {
    return pos.candidateOpportunities?.[0]?.onboardingEmailSentAt ?? null;
  },
  getCandidate: (
    pos: OnboardingPosition
  ): OnboardingCandidateOpportunity['candidate'] | null => {
    return pos.candidateOpportunities?.[0]?.candidate ?? null;
  },
};
